/* eslint-disable global-require */

import axios from './axios'
import { readTranslations } from '../services/app/app.api'

const cache = new Map<string, Record<string, string>>()
const pendingReq = new Map<string, Promise<Record<string, string>>>()

const fetchTranslations = async (locale: string): Promise<Record<string, string>> => {
  try {
    const response = await readTranslations(locale)
    return response.data
  } catch (e) {
    console.error(e)
    //Fallback
    return require('../i18n/builtIn.json')
  }
}

export const getTranslations = async (locale: string) => {
  if (cache.has(locale)) {
    return cache.get(locale)!
  }

  if (pendingReq.has(locale)) {
    return pendingReq.get(locale)!
  }

  const requestPromise = fetchTranslations(locale)
  pendingReq.set(locale, requestPromise)

  try {
    const result = await requestPromise
    cache.set(locale, result)
    return result
  } finally {
    pendingReq.delete(locale)
  }
}

export async function loadLocaleData(locale: string): Promise<Record<string, string>> {
  return getTranslations(locale)
}
